import { render, staticRenderFns } from "./ReasonList.vue?vue&type=template&id=17cf7f3e"
import script from "./ReasonList.vue?vue&type=script&lang=js"
export * from "./ReasonList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports